import {
  serverItemsToProGallery,
  proGalleryItemsToWixCode,
} from '@wix/pro-gallery-items-formatter';
import _ from 'lodash';
import imageClientApiService from './imageClientService';
import { FULLSCREEN_STYLEPARAMS_KEYS } from '../consts/styleParams'

const TRANSPARENT_IMAGE_URL =
  'https://static.wixstatic.com/media/a9ff3b_a268304dd2124c829801c489448477a0~mv2.png';

export const getWixCodeAlbumData = (albumData, sets) => {
  const { template } = albumData;
  albumData.albumId = albumData.id;
  if (albumData.cover && albumData.cover.photoMetadata) {
    albumData.coverUrl =
      imageClientApiService.getImageItemUrlWithWatermark(
        albumData.cover,
        albumData.watermark,
      ) ||
      (albumData.cover && albumData.cover.mediaUrl);
  } else if (albumData.cover) {
    albumData.coverUrl = albumData.cover.thumbnail;
  }
  const wixCodeCoverItem = {
    type: 'image',
    src:
      albumData.cover && albumData.cover.isSecure
        ? imageClientApiService.getWixCodeImageWithWatermark(
          albumData.cover,
          albumData.watermark,
        )
        : albumData.coverUrl,
  };

  if (
    albumData.motherSiteUrl &&
    albumData.motherSiteUrl.indexOf('editor.wix.com') > -1
  ) {
    albumData.motherSiteUrl = '';
  }
  albumData.showCart = albumData.isStoreAlbum;
  albumData.freeArtStore = !albumData.isStoreAlbum;
  albumData.transparent =
    (albumData.template && albumData.template.transparentImageUrl) || TRANSPARENT_IMAGE_URL;

  albumData.coverOptions = {};
  albumData.gogOptions = {
    styleParams: { watermark: albumData.watermark },
    settings: {
      watermark: albumData.watermark,
      freeArtStore: true,
      ignoreFullscreen: true,
    },
  };
  albumData.setPageBackLink = sets.length > 1 ? '/sets' : `/`;
  albumData.coverLink = sets.length > 1 ? '/sets' : `/set/${sets[0].id}`;

  if (albumData.displayBrand) {
    if (albumData.brand.type === 'LOGO' && albumData.brand.logo) {
      albumData.logoItems = [
        {
          type: 'image',
          src: albumData.brand.logo.mediaUrl,
        },
      ];
      albumData.brand.name = '';
      albumData.logoUrl = albumData.brand.logo.mediaUrl;
    }
  } else if (albumData.brand) {
    albumData.brand.name = '';
  }


  albumData.gogItems = sets.filter(x => x.items && x.items.length > 0).map(set => {
    const item = set.items[0];
    const src = item.src || item.mediaUrl;
    return {
      type: 'image',
      title: set.name,
      src,
      link: '/set/' + set.id,
      imageToken: item.imageToken,
    };
  });

  albumData.coverGalleryOption = {
    styleParams: { watermark: albumData.watermark },
    settings: { watermark: albumData.watermark, freeArtStore: true },
  };

  albumData.albumDate = albumData.displayDate ? albumData.albumDate : '';

  albumData.coverItems = [
    {
      type: 'image',
      title: template.reverseCoverTitleAndDescription
        ? albumData.albumDate
        : albumData.albumName,
      description: template.reverseCoverTitleAndDescription
        ? albumData.albumName
        : albumData.albumDate,
      src: albumData.transparent,
    },
  ];

  albumData.styleParams = _.omit(
    albumData.styleParams,
    FULLSCREEN_STYLEPARAMS_KEYS,
  );

  albumData.coverItemMobile = [wixCodeCoverItem];

  if (!albumData.template.coverIsBackground) {
    albumData.coverItems.push(wixCodeCoverItem);
  }
  return albumData;
};

export const getWixCodeGalleryItems = (albumGalleries, albumData) => {
  const { motherSiteMetaSiteId, id } = albumData;
  albumData.albumId = id;
  const firstGallery = albumGalleries[0];
  albumGalleries.forEach((gallery, idx) => {
    let serverItems = _.chain(gallery.items)
      .filter(x => x.mediaUrl)
      .value();

    serverItems = serverItemsToProGallery(serverItems);

    const thumbnailsItems = _.chain(gallery.items)
      .filter(x => !x.mediaUrl && x.thumbnail)
      .value();

    const wixCodeServerItems = proGalleryItemsToWixCode(serverItems).map(x => ({
      ...x,
      defaultSetId: firstGallery.id,
    }));

    const wixCodeThumbnailItems = thumbnailsItems.map(x => ({
      type: x.mediaType === 'video' ? 'video' : 'image',
      src: x.thumbnail,
      orderIndex: x.orderIndex,
    }));

    gallery.items = [...wixCodeServerItems, ...wixCodeThumbnailItems];
  });

  const wixCodeRes = albumGalleries.map(gallery => ({
    ...gallery,
    zipUrl: `https://www.wix.com/_api/albums-node-server/downloadZip?metaSiteId=${motherSiteMetaSiteId}&instanceId=${id}&state=PUBLISHED&setId=${gallery &&
      gallery.id}`,
  })).filter(x => x.items && x.items.length > 0);

  return wixCodeRes;
};
